import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalA from "./Modals/ModalA";
import "./NatijehLink.css";
import { MainContext } from "../contexts/MainContext";
import ApiPutX4 from "./ApiServicesX/ApiPutX4";

export default function NatijehLink({ style }) {
  let { result, setResult, UserShapeId } = useContext(MainContext)
  const [isShowModal, setIsShowModal] = useState(false);
  const [sta2, setSta2] = useState(true)

  const chaneValue = (e) => {
    setResult(e.target.value)
  }

  const editeResult = () => {

    let obj = {
      id: UserShapeId,
      shapeValue: "string",
      lotName: "string",
      result: result,
      titleID: 0,
      createDate: "2025-07-07T10:17:03.488Z",
      agQuestionId: 0,
      userId: 0
    }
    ApiPutX4('/api/AgMain/editeUserShape', obj, setResult)
    triggerEsc()
  }
  const triggerEsc = () => {
    const escEvent = new KeyboardEvent("keydown", {
      key: "Escape",
      code: "Escape",
      keyCode: 27,
      which: 27,
      bubbles: true
    });
    document.dispatchEvent(escEvent);
  };

  return (
    <>
      <Link
        ///برای کنترل عرض  دکمه
        className={style ? "linkBtn  mt-5" : "linkBtn inputA "}
        to=""
        onClick={() => {
          setIsShowModal(true);
          setInterval(() => {
            setIsShowModal(false);
          }, 0.5);
        }}
      >
        ثبت نتیجه
      </Link>

      <ModalA state={isShowModal} state2={sta2}>
        <div className="ramlpic-modalA-div centerc ">
          <p>نتیجه زاییچه :</p>
          <div className="ramlpic-modalA-div-kadr ">

            <textarea
              value={result}
              onChange={(e) => chaneValue(e)}
            ></textarea>

          </div>
          <button className="btn btn-info"
            id="myButton"
            onClick={editeResult}
          >ثبت نتیجه</button>
        </div>


      </ModalA>

      <div className="ramlpic-modalA-divB centerc ">
        <div className="ramlpic-modalA-divB-kadr ">
          <p>نتیجه زاییچه :</p>

          <h6>
            {result}
          </h6>

        </div>
      </div>
    </>
  );
}
